var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "container"
  }, [_c('v-autocomplete', {
    ref: "autocomplete",
    attrs: {
      "label": _vm.$t('objects.tag.tags'),
      "loading": _vm.isLoading,
      "items": _vm.items,
      "item-text": "value",
      "item-value": "id",
      "search-input": _vm.search,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "clearable": "",
      "flat": "",
      "outlined": "",
      "multiple": "",
      "return-object": "",
      "data-test-tag-selection": "",
      "menu-props": {
        maxWidth: _vm.menuWidth,
        offsetY: true
      }
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.search = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.search = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('tag-chip', {
          attrs: {
            "value": item,
            "size": "small"
          }
        })];
      }
    }, {
      key: "no-data",
      fn: function fn() {
        return [_vm.isLoading ? _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("tag.selectTags.searching")) + " ")])], 1)], 1) : _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.search && _vm.search.length >= 2 ? _vm.$t("tag.selectTags.noneFound") : _vm.$t("tag.selectTags.typeToSearch")) + " ")])], 1)], 1)];
      },
      proxy: true
    }, {
      key: "item",
      fn: function fn(_ref2) {
        var item = _ref2.item,
            attrs = _ref2.attrs,
            on = _ref2.on;
        return [_c('v-list-item', _vm._g(_vm._b({
          staticClass: "tag-list-item",
          attrs: {
            "data-test-tag-selection-item": ""
          }
        }, 'v-list-item', attrs, false), on), [_c('v-list-item-content', {
          staticStyle: {
            "min-width": "0"
          }
        }, [_c('v-list-item-title', {
          staticClass: "d-flex align-center",
          staticStyle: {
            "min-width": "0"
          }
        }, [_c('v-sheet', {
          staticClass: "mr-2 flex-shrink-0",
          attrs: {
            "width": "18px",
            "height": "18px",
            "rounded": "",
            "color": item.color
          }
        }), _c('span', {
          staticClass: "text-truncate",
          staticStyle: {
            "min-width": "0"
          }
        }, [_vm._v(_vm._s(item.value))])], 1), item.description ? _c('v-list-item-subtitle', {
          staticClass: "text-truncate",
          staticStyle: {
            "min-width": "0"
          }
        }, [_vm._v(" " + _vm._s(item.description) + " ")]) : _vm._e()], 1)], 1)];
      }
    }]),
    model: {
      value: _vm.selectedTags,
      callback: function callback($$v) {
        _vm.selectedTags = $$v;
      },
      expression: "selectedTags"
    }
  }), _c('div', {
    staticClass: "d-flex mt-n7 mb-n2"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "x-small": "",
      "text": ""
    },
    on: {
      "click": _vm.openManageTags
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("tag.manageTags")) + " ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }